var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WashYourHand50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25,10.5c0,0.828-0.672,1.5-1.5,1.5S22,11.328,22,10.5c0-1,1.5-2.5,1.5-2.5S25,9.5,25,10.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31,16.5c0,1.381-1.119,2.5-2.5,2.5S26,17.881,26,16.5c0-1.667,2.5-4.5,2.5-4.5S31,14.833,31,16.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.5,29c0.828,0,1.5-0.672,1.5-1.5S37.328,26,36.5,26c-0.689,0-8.875,0-11.611,0L25,25 c3.455,0,10.207,0,10.5,0c0.828,0,1.5-0.672,1.5-1.5S36.328,22,35.5,22C34.82,22,18,22,18,22s1.703-1.524,1.783-1.61 c0.698-0.757,0.985-1.335,1.074-1.651c0.368-1.297,0.022-2.725-0.967-3.714l-0.001-0.001c0,0-5.108,3.91-7.126,5.455 C11.525,21.427,11,22.747,11,24.607V33c0,2.209,1.791,4,4,4c0,0,16.291,0,16.5,0c0.828,0,1.5-0.672,1.5-1.5S32.328,34,31.5,34 c-0.487,0-4.377,0-7.5,0l0.111-1c3.723,0,11.095,0,11.389,0c0.828,0,1.5-0.672,1.5-1.5S36.328,30,35.5,30c-0.647,0-7.906,0-11.056,0 l0.111-1C28.038,29,36.19,29,36.5,29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WashYourHand50);
export default __webpack_public_path__ + "static/media/icons8-wash-your-hand-50.9864e8d8146d8249f883055f9406bb10.svg";
export { ForwardRef as ReactComponent };